const config = {
    sydle_one_api: process.env.REACT_APP_SYDLE_ONE_API || '',
    sydle_one_env: process.env.REACT_APP_SYDLE_ONE_ENV || '',
    sydle_one_site_token: process.env.REACT_APP_SYDLE_ONE_SITE_TOKEN || '',
    config_object: process.env.REACT_APP_CONFIG_OBJECT || ''
};

Object.freeze(config);

export default config;